<div class="d-flex justify-content-end my-1">
	<button class="btn btn-secondary" (click)="openAddBankAccountModal()"><i class="fas fa-plus"></i> Add Account</button>

	<button class="btn btn-outline-dark" (click)="openViewDocusealHistory()"><i class="fas fa-history"></i> View Letter Signing History</button>
</div>

@if (accountList()?.customer?.length > 0) {
	<h3>Owner</h3>
	<div>
		<app-bank-account-detail [accountItem]="accountList()?.customer" [customer]="viewCustomer" (addBankAccount)="openAddBankAccountModal($event)"></app-bank-account-detail>
	</div>
}

@if (contacts()?.length > 0) {
	<div class="mt-3">
		<h3>Guarantor</h3>
		@for (k of contacts(); track k) {
			<div>
				<app-bank-account-detail [accountItem]="accountList()?.contact[k]" [customer]="viewCustomer" [contact]="getAccountContactDetails(k)" (addBankAccount)="openAddBankAccountModal($event)"></app-bank-account-detail>
			</div>
		}
	</div>
}
